<template>
  <Shop :id="data.id" />
</template>

<script>
import Shop from '@kvass/shop'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        id: '',
      }),
    },
  },
  components: {
    Shop,
  },
}
</script>
